
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

// Create an instance of axios with default settings
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor to include the token in the headers
axiosInstance.interceptors.request.use(
  (config) => {
  const token = localStorage.getItem('userToken');
    if (token) {
      config.headers["x-access-token"] = token; // Set the token in the header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export const getProfileQuestion = async (payload) => {
  try {
    const response = await axiosInstance.post("/getProfileQuestion",payload);
    return response.data;
  } catch (error) {
    console.error("getProfileQuestion API Error:", error);
    throw error;
  }
};
export const saveProfileQuestion = async (payload) => {
  try {
    const response = await axiosInstance.post("/saveProfileQuestionAnswer",payload);
    return response.data;
  } catch (error) {
    console.error("saveProfileQuestion API Error:", error);
    throw error;
  }
};
export const getCommunity = async (payload) => {
  try {
    const response = await axiosInstance.post("/getTopCommunities",payload);
    return response.data;
  } catch (error) {
    console.error("getCommunity API Error:", error);
    throw error;
  }
};
export const getUserDetails = async (payload) => {
  try {
    const response = await axiosInstance.post("/getUserDetails",payload);
    return response.data;
  } catch (error) {
    console.error("getUserDetails API Error:", error);
    throw error;
  }
};
export const getProfileDetails = async (payload) => {
  try {
    const response = await axiosInstance.post("/getProfileDetails",payload);
    return response.data;
  } catch (error) {
    console.error("getProfileDetails API Error:", error);
    throw error;
  }
};
export const removeUserCommunities = async (payload) => {
  try {
    const response = await axiosInstance.post("/removeUserCommunities",payload);
    return response.data;
  } catch (error) {
    console.error("removeUserCommunities API Error:", error);
    throw error;
  }
};
export const changeVisibilityStatus = async (payload) => {
  try {
    const response = await axiosInstance.post("/changeVisibilityStatus",payload);
    return response.data;
  } catch (error) {
    console.error("changeVisibilityStatus API Error:", error);
    throw error;
  }
};
export const editProfileDetails = async (payload) => {
  try {
    const response = await axiosInstance.post("/editUserDetails",payload);
    return response.data;
  } catch (error) {
    console.error("editProfileDetails API Error:", error);
    throw error;
  }
};
export const removeUserAccount= async (payload) => {
  try {
    const response = await axiosInstance.post("/removeUser",payload);
    return response.data;
  } catch (error) {
    console.error("removeUserAccount API Error:", error);
    throw error;
  }
};
export const editUserEmail= async (payload) => {
  try {
    const response = await axiosInstance.post("/editUserEmail",payload);
    return response.data;
  } catch (error) {
    console.error("editUserEmail API Error:", error);
    throw error;
  }
};
export const checkEmailToken= async (payload) => {
  try {
    const response = await axiosInstance.post("/checkEmailToken",payload);
    return response.data;
  } catch (error) {
    console.error("checkEmailToken API Error:", error);
    throw error;
  }
};

export const changeUserPassword = async (payload) => {
  try {
    const response = await axiosInstance.post("/changeUserPassword",payload);
    return response.data;
  } catch (error) {
    console.error("changeUserPassword API Error:", error);
    throw error;
  }
};








